module.exports = __webpack_public_path__ + "img/table.dfd2fae8.svg";